import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import {
  SimpleLoading,
  PromotionalFooterPure,
  ButtonHLPure,
  HeaderHLPure,
  DialogSystemGLPure,
  ArrowBtnHLPure,
  BoxSomeHeadersGLPure
} from "../../pures";

import './contract-request-status.view.css';
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { NegotiationCntractService, UserSignatureProfileService, WorkflowService } from "../../../services";
import FollowUpConfigurationsView from "../follow-up-actions-contracts/follow-up-actions-contracts-configuration.view";
import ContractGeneratedView from "../follow-up-actions-contracts/questionsSection/contract-generated-view";

const ContractRequestStatusView = (props) => {
  const {
    clientContractId,
    loading,
    contract,
    showLoadingRequesting,
    toggleLoadingRequesting,
    showCompletedRequesting,
    toggleCompletedRequesting,
    showErrorRequesting,
    toggleErrorRequesting,
    questions,
    token,
    user,
    errorMessage,
    workflowNegotiation,
    workflowContract,
    membersChat,
    changeRoute
  } = props

  const { t } = useTranslation()
  let history = useHistory();

  const url = process.env.REACT_APP_MIFIRMA_API;
  let negotiationCntractService = new NegotiationCntractService(url)
  let userSignatureProfileService = new UserSignatureProfileService(url);
  let workflowService = new WorkflowService(url);

  const mobileResolution = useMediaQuery("(max-width:660px)");

  const [showDetails, setShowDetails] = useState(false);
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [urlPdf, setUrlPdf] = useState("")
  const [questionsAnswered, setQuestionsAnswered] = useState([])
  const [contractName, setContractName] = useState('')
  const [contractorName, setContractorName] = useState('')
  const [solicitudDate, setSollicitudDate] = useState('')
  const [contractorsName, setContractorsName] = useState('')
  const [headerTitle, setHeaderTitle] = useState(t("contractRequestStatusView.header.title"))
  const [urlDocs, setUrlDocs] = useState('')
  const [displayBtnNext, setDisplayBtnNext] = useState('block')
  const [displayBtnSign, setDisplayBtnSign] = useState('block')
  const [statusContract, setStatusContract] = useState(0)

  //renderiza el pdf y guarda la informacion en una variable para evitar que se actualice el pdfRender cuando se actuaiza el estado
  const pdf = useMemo(() => <PdfReader className="pdfReader" url={urlPdf} awsURL showDownloadPDF={true} />, [urlPdf])

  const nextBtnStyle = {
    display: displayBtnNext
  }

  const signBtnStyle = {
    display: displayBtnSign
  }

  useEffect(() => {
    if (contract && contract.contractors) {
      let contractors = ''
      setContractName(contract.name)
      setContractorName(contract.user.email)
      setSollicitudDate(contract.createdDate)
      for (let index = 0; index < contract.contractors.length; index++) {
        let nameContract = contract.contractors[index].contractor.name
        if (index === 0) {
          contractors = `${nameContract}`
        } else {
          contractors = `${contractors}, ${nameContract}`
        }
      }
      setContractorsName(contractors)
      setTimeout(() => {
        toggleLoadingRequesting(false)
      }, 4000)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract])

  useEffect(() => {
    let urlContract = contract && contract.updatedDocumentPathPdf && contract.updatedDocumentPathPdf !== '' && contract.updatedDocumentPathPdf !== null && contract.updatedDocumentPathPdf !== undefined ? contract.updatedDocumentPathPdf : contract.originalDocumentPathPdf
    let urlContractDocs = contract && contract.updatedDocumentPathWord && contract.updatedDocumentPathWord !== '' && contract.updatedDocumentPathWord !== null && contract.updatedDocumentPathWord !== undefined ? contract.updatedDocumentPathWord : contract.originalDocumentPathWord
    setUrlPdf(urlContract)
    setUrlDocs(urlContractDocs)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract])

  useEffect(() => {
    if (!membersChat || membersChat.length === 0) return

    let memberExist = membersChat.map((member) => user.userMetaData.userA3Cloud.email === member.email)
    let memberIncludes = memberExist.includes(true)
    let displayBtns = (memberIncludes) ? 'block' : 'none'
    setDisplayBtnNext(displayBtns)
    setDisplayBtnSign(displayBtns)

    if (workflowNegotiation && workflowNegotiation.id && membersChat) getWorkFlowStatus()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [membersChat, workflowNegotiation])

  //function to exit
  const backButton = () => {
    changeRoute('home')
  }


  const handleSignDocument = async () => {
    toggleLoadingRequesting(true)
    let contractInfo = {
      name: contractName,
      url: urlPdf,
      workflowExecutionId: (workflowContract && workflowContract.id) ? workflowContract.id : '',
      contractId: (contract && contract.id) ? contract.id : null,
      questionnaireId: (contract && contract.questionnaireId) ? contract.questionnaireId : null
    }

    //All signature profiles from user
    let userProfiles = await userSignatureProfileService.getUserSignatureProfiles(token, user.userMetaData.userMifirma.id);
    userProfiles.data = userProfiles.data.map((profile) => {
      if (userProfiles.data) {
        profile.title = profile.signatureProfile.name.slice(0, 42)
        profile.text = profile.signatureProfile.description.slice(0, 78)
        profile.img = profile.signatureProfile.icon;
        profile.imgBackCard = profile.signatureProfile.backgroundIcon;
        profile.url = (profile.signatureProfileId === 2) ? "/sign-request-by-volume" :
          {
            pathname: `/signature-request-profile/${profile.signatureProfileId}`,
            params: { dataItem: profile }
          }
      }
      return profile;
    });
    let profileCorrect = userProfiles.data?.filter((profile) => Number(profile.signatureProfileId) === 1)
    history.push({
      pathname: `/signature-request-profile/1`,
      params: {
        dataItem: profileCorrect[0],
        contractInfo: contractInfo
      }
    });
    toggleLoadingRequesting(false)
  }


  const handleSendNegotiatecontract = async () => {
    toggleLoadingRequesting(true)
    let messageError = 'Ocurrió un error al crear la relación con el inbox y el workflow'
    let contractId = clientContractId
    try {
      let createWorkflowInbox = await negotiationCntractService.createWorkflowInboxNegotiation(contractId, token)
      if (createWorkflowInbox && createWorkflowInbox.data && Number(createWorkflowInbox.statusCode) === 200) {
        let url = createWorkflowInbox.data && createWorkflowInbox.data.url ? createWorkflowInbox.data.url : "/"
        toggleLoadingRequesting(false)
        toggleCompletedRequesting(true)
        history.push(url)
      } else {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(true, messageError)
        setTimeout(() => {
          toggleErrorRequesting(false)
        }, 3000)
      }
    } catch (error) {
      toggleLoadingRequesting(false)
      toggleErrorRequesting(true, messageError)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 3000)
    }
  }

  const handleRequestQuestionnaire = () => {
    setNameComponentUser("Consultar cuestionario");
    setShowDetails(true);
  }

  const handleRequestContract = () => {
    setNameComponentUser("Consultar contrato");
    setShowDetails(true);
  }

  const getWorkFlowStatus = async () => {
    toggleLoadingRequesting(true)
    let messageError = 'ocurrió un error al consultar el estatus del workflow'
    let workflowExecutionId = workflowNegotiation.id
    try {
      let workflowExecution = await workflowService.getWorkFlowExecutionById(workflowExecutionId, token)
      if (workflowExecution && workflowExecution.data && Number(workflowExecution.statusCode) === 200) {
        // if (Number(workflowExecution.data.workflowStatusDescriptions.statusCurrent.status) === Number(process.env.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102620)) {
        //   setDisplayBtnNext('none')
        // }
        let status = (workflowExecution.data.workflowStatusDescriptions && workflowExecution.data.workflowStatusDescriptions.statusCurrent && workflowExecution.data.workflowStatusDescriptions.statusCurrent.status) ? workflowExecution.data.workflowStatusDescriptions.statusCurrent.status : 0
        setStatusContract(status)
        toggleLoadingRequesting(false)
      } else {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(true, messageError)
        setTimeout(() => {
          toggleErrorRequesting(false)
        }, 3000)
      }
    } catch (error) {
      toggleLoadingRequesting(false)
      toggleErrorRequesting(true, messageError)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 3000)
    }
  }

  const sendToConsultNegotiation = async () => {
    let workflowExecutionId = workflowNegotiation.id
    history.push(`/consult-negotiation/${clientContractId}/${workflowExecutionId}`);
  }

  return (
    <div className="contractRequestStatusView-wrapper">
      {loading ? (
        <SimpleLoading />
      ) : (
        <div>
          <DialogSystemGLPure
            toggleLoadingRequesting={toggleLoadingRequesting}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            message={errorMessage}
            showErrorRequesting={showErrorRequesting}
          />
          {
            showDetails && nameComponentUser ?
              (
                <FollowUpConfigurationsView
                  nameComponentUser={nameComponentUser}
                  hideShowDetails={() => {
                    setShowDetails(false);
                    setNameComponentUser("");
                  }}
                  status={100515}
                  setShowDetails={setShowDetails}
                  setNameComponentUser={setNameComponentUser}
                  setUrlPdf={setUrlPdf}
                  setQuestionsAnswered={setQuestionsAnswered}
                  {...props}
                />
              )
              : (
                <div className="contractRequestStatusView-body">
                  <div className="contractRequestStatusView-data-contract">
                    <BoxSomeHeadersGLPure
                      titleOne={t('followUpActionsContractsView.contract')}
                      subtitleOne={contractName}
                      titleTwo={t('followUpActionsContractsView.solicitante')}
                      subtitleTwo={contractorName}
                      titleThree={t('followUpActionsContractsView.date.request')}
                      subtitleThree={solicitudDate}
                      titleFour={t('followUpActionsContractsView.companys.contractor')}
                      subtitleFour={contractorsName}
                    />
                  </div>
                  <div className="contractRequestStatusView-template-container" >
                    {pdf}
                  </div>

                  <div className="contractRequestStatusView-btns-container">
                    <div className="contractRequestStatusView-btns-web">
                      <ButtonHLPure
                        nameBtn={t("followUpActionsContractsView.button.exit")}
                        primary={false}
                        onClickBtn={(e) => backButton(e)}
                      />
                    </div>
                    <div className="contractRequestStatusView-btns-movil" >
                      <ArrowBtnHLPure
                        textArrowBtn={t("contractRequestStatusView.btn.request.questionnaire")}
                        primary={false}
                        onClickArrowBtn={(e) => handleRequestQuestionnaire(e)}
                      />
                    </div>
                    <div className="contractRequestStatusView-btns-movil" >
                      <ArrowBtnHLPure
                        textArrowBtn={t("contractRequestStatusView.btn.request.document")}
                        primary={false}
                        onClickArrowBtn={(e) => handleRequestContract(e)}
                      />
                    </div>
                    <div className="contractRequestStatusView-btns-web" style={signBtnStyle}>
                      <ButtonHLPure
                        nameBtn={t("contractRequestStatusView.btn.sign.contract")}
                        primary={false}
                        onClickBtn={(e) => handleSignDocument(e)}
                      />
                    </div>
                    <div className="" style={nextBtnStyle}>
                      <ButtonHLPure
                        nameBtn={(statusContract) === Number(process.env.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102620) ? t("contractRequestStatusView.btn.request.negotiation") : t("contractRequestStatusView.btn.negotiate.contract")}
                        primary={true}
                        onClickBtn={(statusContract) === Number(process.env.REACT_APP_STATUS_NEGOTIATE_CONTRACT_102620) ? () => sendToConsultNegotiation() : (e) => handleSendNegotiatecontract(e)}
                      />
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      )}
    </div>
  );
};

export default ContractRequestStatusView;
